import { render } from "./UI.vue?vue&type=template&id=1da6b342"
import script from "./UI.vue?vue&type=script&lang=js"
export * from "./UI.vue?vue&type=script&lang=js"
script.render = render

export default script